import { ReactNode, useEffect } from 'react'
import {
  Collapse,
  IconButton,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
} from '@mui/material'

import { useToggle } from 'src/hooks'
import { ChevronUpIcon } from 'src/assets/icons/v2/ChevronUpIcon'
import { ChevronDownIcon } from 'src/assets/icons/v2/ChevronDownIcon'
import { DeleteIcon } from 'src/assets/icons'
import useStyles from './styles'
import { ILocationItem } from 'src/types/locations.type'

interface Props {
  children: ReactNode
  name: string
  index: number
  deleteHandler: (index: number) => void
  location: ILocationItem
}

const CollapseItem = ({ children, name, index, deleteHandler, location }: Props) => {
  const [toggle, handleCollapse] = useToggle()
  const theme = useTheme()
  const classes = useStyles()

  useEffect(() => {
    if (
      location.location_name === '' &&
      location.location_address === '' &&
      location.latitude === 0 &&
      location.longitude === 0 &&
      location.radius === 50
    ) {
      handleCollapse(false)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <ListItemButton
        onClick={() => handleCollapse()}
        disableGutters
        sx={{ borderRadius: '10px', px: '10px' }}
        // className={classes.listItemButton}
      >
        <ListItemIcon>
          {toggle ? (
            <ChevronUpIcon size={28} color={theme.palette.custom.darkBlue2} />
          ) : (
            <ChevronDownIcon size={28} color={theme.palette.custom.darkBlue2} />
          )}
        </ListItemIcon>
        <ListItemText
          // className={classes.collapseItem}
          disableTypography
        >
          <Typography
          // className={`${classes.itemText} ${classes.itemPropertyText}`}
          >
            {name}
          </Typography>
        </ListItemText>

        <IconButton
          sx={{ ml: 'auto', p: 1 }}
          onClick={(e) => {
            e.stopPropagation()
            deleteHandler(index)
          }}
        >
          <DeleteIcon className={classes.deleteIcon} />
        </IconButton>
      </ListItemButton>
      <Collapse in={toggle} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </>
  )
}

export { CollapseItem }
